import { registerGeoService } from "@esignal/polygon-service-api";
import { GeoServiceImpl } from "./internal/GeoServiceImpl";
import { ServiceCacheImpl } from "./internal/ServiceCacheImpl";
import { registerServiceCache } from "@esignal/polygon-service-api";
import { isUseWorker, setUseWorker } from "./internal/sww/USE_WORKER";
import { setUseIDBCache } from "./internal/sww/USE_IDB";
import { GeoServiceSwwProxy } from "./internal/sww/GeoServiceSwwProxy";

export const initPolygonService = () => {
	setUseWorker(true);
	setUseIDBCache(false);

	const geoInstance = isUseWorker() ? new GeoServiceSwwProxy() : new GeoServiceImpl();
	registerGeoService(geoInstance);

	const servInstance = new ServiceCacheImpl(geoInstance);
	registerServiceCache(servInstance);
};

// init();
